import { GameType } from "@apiserver-rest/ponder-data-client-base";

export const DeckTypes = new Map<GameType, string[]>([
    [GameType.Magic, [
        "None",
        "Commander",
        "Conspiracy",
        "Cube",
        "Legacy",
        "Modern",
        "Momir",
        "Oathbreaker",
        "Pauper",
        "Pioneer",
        "Standard",
        "Vintage"
    ]]
]);